import { render, staticRenderFns } from "./notification-form.vue?vue&type=template&id=22530408&scoped=true&lang=pug&"
import script from "./notification-form.vue?vue&type=script&lang=ts&"
export * from "./notification-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22530408",
  null
  
)

export default component.exports